module.exports = __webpack_public_path__ + "img/bg2.bd29ae69.png";